import React, { useState } from 'react'
import { Button } from '../../theme'
import { useClaimStatus, useFaucetClaim, useGetNounce } from '../../hooks/useYTSFaucet'
import styled from 'styled-components'
import { ChainId } from '@yetiswap/sdk'
import { ZERO_ADDRESS } from '../../constants'
import { useActiveWeb3React } from '../../hooks'
import { useAddPopup } from '../../state/application/hooks'
import { PopupMessage } from '../NFTMarketPlace/utils/NFTErrorHandleHelper'
import ReCAPTCHA from 'react-google-recaptcha'
import { useIsDarkMode } from '../../state/user/hooks'

const ClaimTitle = styled.div`
  text-align: center;
  width: 100%;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
`

const ClaimButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const ConnectWarning = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 3rem;
  font-weight: bold;
`

const CaptchaWrapper = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
`

export default function YTSFaucet() {
  const { account, chainId } = useActiveWeb3React()
  const accountControl = account ? account : ZERO_ADDRESS
  const claimStatus = useClaimStatus(accountControl)
  const nounce = useGetNounce()
  const [claimYTS] = useFaucetClaim(nounce)
  const addPopup = useAddPopup()
  const darkMode = useIsDarkMode()
  const [captchaStatus, setCaptchaStatus] = useState<boolean>(false)

  function faucetClaim() {
    if (captchaStatus) {
      claimYTS().catch((ex: any) => {
        if (ex && ex.data && ex.data.message) {
          let message = ''
          if (ex.data.message.indexOf('You have balance') !== -1) {
            message = 'You already have YTS in your wallet'
          } else if (ex.data.message.indexOf('transfer amount exceeds balance') !== -1) {
            message = 'The amount of YTS in the contract is insufficient. Please contact admin'
          } else {
            message = ex.data.message.substring(19, ex.data.message.length)
          }

          addPopup(PopupMessage(message, false), 'FAUCET_POPUP')
        }
      })
    } else {
      addPopup(PopupMessage('Please verify captcha', false), 'FAUCET_POPUP')
    }
  }

  function onChange(value: any) {
    if (value) {
      setCaptchaStatus(true)
    } else {
      setCaptchaStatus(false)
    }
  }

  return chainId !== ChainId.FUJI ? (
    <ConnectWarning>
      PLEASE CONNECT TO <br /> AVALANCHE FUJI C-CHAIN
    </ConnectWarning>
  ) : (
    <div>
      <ClaimTitle>Claim 5,000 YTS for FUJI TEST NET</ClaimTitle>
      <CaptchaWrapper>
        <ReCAPTCHA
          theme={darkMode ? 'dark' : 'light'}
          sitekey="6LdVeCIbAAAAAHR0-FO-dv86fNxcj0AhER_vceCf"
          onChange={onChange}
        />
      </CaptchaWrapper>
      <ClaimButton>
        {parseInt(claimStatus) === 0 ? (
          <Button disabled={!captchaStatus} onClick={faucetClaim}>
            Claim
          </Button>
        ) : (
          <div>Already Claimed</div>
        )}
      </ClaimButton>
    </div>
  )
}
